import { render, staticRenderFns } from "./score_10_19.vue?vue&type=template&id=71c668ba&scoped=true&"
import script from "./score_10_19.vue?vue&type=script&lang=js&"
export * from "./score_10_19.vue?vue&type=script&lang=js&"
import style0 from "./score_10_19.vue?vue&type=style&index=0&id=71c668ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c668ba",
  null
  
)

export default component.exports